export default __webpack_public_path__ + "static/media/DSC09050.354f1b60.jpg";